package com.gsb.vyapar.bhagya.presentation.auth.util

import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTManager
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.interactor.util.*
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.auth.uistate.getAuthUiState
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.util.*
import kotlinx.coroutines.delay
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

fun connectToServer() {
    showLoading()
    launchDefault {
        MQTTManager.connect()
        while(!MQTTManager.connected.value) {
            delay(1000)
        }
        hideLoading()
    }
}

@OptIn(ExperimentalTime::class)
fun requestOtpMobile(to: String, message: String, status: (Result<Unit>) -> Unit) {
    showLoading()
    launchDefault {
        MQTTManager.connect()
        var timoutCount = 0
        var isSuccess: Boolean
        var reason = ""
        while(!MQTTManager.connected.value && timoutCount <= 5) {
            delay(1000)
            timoutCount += 1
        }
        isSuccess = MQTTManager.connected.value
        if (isSuccess) {
            val requestId = Clock.System.now().epochSeconds.toString()
            MQTTManager.subscribe(requestId)
            delay(1000)
            MQTTManager.publish("PGsbVyaparBhagya", getMobileMessage(requestId, to, message).toMessageString())
            timoutCount = 0
            while (MQTTManager.messages.size <= 0 && timoutCount <= 5) {
                delay(1000)
                timoutCount += 1
            }
            val messages = MQTTManager.messages
            isSuccess = false
            messages.forEach {
                if (it.isSuccessMessage(requestId)) {
                    isSuccess = true
                } else if (it.isFailureMessage(requestId)) {
                    isSuccess = false
                    reason = it.failureReason(requestId).orEmpty()
                }
            }
            MQTTManager.unsubscribe(requestId)
        }
        hideLoading()
        if (!isSuccess && reason.isEmpty()) {
            reason = "Time Out, Please try again"
        }
        if (isSuccess) {
            showSuccess("OTP successfully sent to $to")
            status(Result.success(Unit))
        } else {
            showError(reason)
            status(Result.failure(Throwable(reason)))
        }
        MQTTManager.disconnect()
    }
}

@OptIn(ExperimentalTime::class)
fun requestOtpEmail(to: String, subject: String, message: String, status: (Result<Unit>) -> Unit) {
    showLoading()
    launchDefault {
        MQTTManager.connect()
        var timoutCount = 0
        var isSuccess: Boolean
        var reason = ""
        while(!MQTTManager.connected.value && timoutCount <= 5) {
            delay(1000)
            timoutCount += 1
        }
        isSuccess = MQTTManager.connected.value
        if (isSuccess) {
            val requestId = Clock.System.now().epochSeconds.toString()
            MQTTManager.subscribe(requestId)
            delay(1000)
            MQTTManager.publish("PGsbVyaparBhagya", getEmailMessage(requestId, to, subject, message).toMessageString())
            timoutCount = 0
            while (MQTTManager.messages.size <= 0 && timoutCount <= 5) {
                delay(1000)
                timoutCount += 1
            }
            val messages = MQTTManager.messages
            isSuccess = false
            messages.forEach {
                if (it.isSuccessMessage(requestId)) {
                    isSuccess = true
                } else if (it.isFailureMessage(requestId)) {
                    isSuccess = false
                    reason = it.failureReason(requestId).orEmpty()
                }
            }
            MQTTManager.unsubscribe(requestId)
        }
        hideLoading()
        if (!isSuccess && reason.isEmpty()) {
            reason = "Time Out, Please try again"
        }
        if (isSuccess) {
            showSuccess("OTP successfully sent to $to  \nIf you don’t receive the email in your inbox, please check your Spam or Junk folder.")
            status(Result.success(Unit))
        } else {
            showError(reason)
            status(Result.failure(Throwable(reason)))
        }
        MQTTManager.disconnect()
    }
}

fun Int.formatSecondsToHHMM(): String {
    val minutes = this / 60
    val remainingSeconds = this % 60
    return minutes.toString().padStart(2, '0') + ":" + remainingSeconds.toString().padStart(2, '0')
}

fun launchLoginMobile() {
    getAuthUiState().resetAuthUiState(false)
    pushView(Screens.Login)
}

fun launchVerifyEmail() {
    getAuthUiState().resetAuthUiState(true)
    pushView(Screens.Login)
}

@OptIn(ExperimentalTime::class)
fun saveUserMobile(mobile: String, proceed: () -> Unit) {
    val oldUser = getState().getUser()
    val updatedUser = oldUser.d.user + (MOBILE to mobile) + (ID to mobile.toU()) + (CREATED to Clock.System.now().epochSeconds.toString()) + (UPDATED to Clock.System.now().epochSeconds.toString())
    saveUserToBackend(updatedUser) {
        saveUser(it)
        proceed()
    }
}

@OptIn(ExperimentalTime::class)
fun saveUserEmail(email: String, proceed: () -> Unit) {
    val oldUser = getState().getUser()
    val updatedUser = oldUser.d.user + (EMAIL to email) + (UPDATED to Clock.System.now().epochSeconds.toString())
    saveUserToBackend(updatedUser) {
        saveUser(it)
        proceed()
    }
}

@OptIn(ExperimentalTime::class)
fun saveUserUI(mobile: String, email: String, image: String, firstName: String, lastName: String, gotra: String, kuldev: String, password: String) {
    if (isMobileError(mobile) || mobile.isEmpty() ||
        isEmailError(email) || email.isEmpty() ||
        isWebsiteError(image) || image.isEmpty() ||
        isFirstNameError(firstName) || firstName.isEmpty() ||
        isLastNameError(lastName) || lastName.isEmpty() ||
        isGotraError(gotra) || gotra.isEmpty() ||
        isKuldevError(kuldev) || kuldev.isEmpty() ||
        isUserIdPasswordError(password) || password.isEmpty()) {
        if (isWebsiteError(image) || image.isEmpty()) {
            showError("Upload the profile picture")
        } else {
            showError("Fill all the details")
        }
    } else {
        val oldUser = getState().getUser()
        val updatedUser = oldUser.d.user + (MOBILE to mobile) + (EMAIL to email) + (IMAGE to image) + (FIRST_NAME to firstName) + (LAST_NAME to lastName) + (GOTRA to gotra) + (KULDEV to kuldev) + (PASSWORD to password) + (UPDATED to Clock.System.now().epochSeconds.toString())
        saveUserToBackend(updatedUser) {
            saveUser(it)
            showSuccess("Saved")
            popView()
        }
    }
}

@OptIn(ExperimentalTime::class)
fun saveUserUIAdmin(user: User, mobile: String, email: String, image: String, firstName: String, lastName: String, gotra: String, kuldev: String, password: String) {
    if (isMobileError(mobile) || mobile.isEmpty() ||
        isEmailError(email) || email.isEmpty() ||
        isWebsiteError(image) || image.isEmpty() ||
        isFirstNameError(firstName) || firstName.isEmpty() ||
        isLastNameError(lastName) || lastName.isEmpty() ||
        isGotraError(gotra) || gotra.isEmpty() ||
        isKuldevError(kuldev) || kuldev.isEmpty() ||
        isUserIdPasswordError(password) || password.isEmpty()) {
        if (isWebsiteError(image) || image.isEmpty()) {
            showError("Upload the profile picture")
        } else {
            showError("Fill all the details")
        }
    } else {
        val updatedUser = user.d.user + (MOBILE to mobile) + (EMAIL to email) + (IMAGE to image) + (FIRST_NAME to firstName) + (LAST_NAME to lastName) + (GOTRA to gotra) + (KULDEV to kuldev) + (PASSWORD to password) + (UPDATED to Clock.System.now().epochSeconds.toString())
        saveUserToBackendAdmin(user, updatedUser) {
            showSuccess("Saved")
        }
    }
}

private fun saveUserToBackendAdmin(oldUser: User, userMap: Map<String, String>, user: (User) -> Unit) {
    showLoading()
    launchDefault {
        val result = KtorClient.updateUser(oldUser.copy(v = oldUser.v + 1, d = User.D(userMap)))
        if (!result.isSuccess) {
            showError("Save User failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            user(oldUser)
        }
        hideLoading()
    }
}

private fun saveUserToBackend(userMap: Map<String, String>, user: (User) -> Unit) {
    showLoading()
    launchDefault {
        var oldUser = getState().getUser()
        oldUser = oldUser.copy(v = oldUser.v + 1, d = User.D(userMap))
        val result = KtorClient.updateUser(oldUser)
        if (!result.isSuccess) {
            showError("Save User failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            user(oldUser)
        }
        hideLoading()
    }
}

fun deleteUser(user: User) {
    showLoading()
    launchDefault {
        val result = KtorClient.deleteUser(user)
        if (!result.isSuccess) {
            showError("Delete User failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            showSuccess("User Account Deleted")
            logout()
        }
        hideLoading()
    }
}

fun saveUser(user: User) {
    updateState(getState().copy(user = user.encodeUserString()))
    Preference.user = getState().user
}

fun logout() {
    updateState(getState().copy(user = User().encodeUserString()))
    Preference.user = getState().user
}

fun isUserLoggedIn(): Boolean {
    return getState().getUser().getId().isNotEmpty()
}

fun isUserAdmin(): Boolean {
    return getState().getUser().getMobile() == ADMIN.value()
}

fun getUserIdUrl(userId: String): String {
    return "u/${userId}"
}

fun getOtherUser(userId: String, user: (User?) -> Unit) {
    val userString = Preference.getCacheData(getUserIdUrl(userId))
    if (userString.isNullOrEmpty()) {
        launchDefault {
            val result = KtorClient.getUser(userId)
            if (result.isSuccess) {
                val userResult = result.getOrNull()
                if (userResult != null) {
                    val finalUser = userResult.toUser()
                    Preference.setCacheData(getUserIdUrl(userId), finalUser.encodeUserString())
                    user(finalUser)
                } else {
                    user(null)
                }
            } else {
                user(null)
            }
        }
    } else {
        return try {
            val cacheUser = userString.decodeUserString()
            launchDefault {
                val result = KtorClient.getUserVersion(userId)
                if (result.isSuccess) {
                    val userVersion = result.getOrNull()
                    if (userVersion != null) {
                        if (userVersion > cacheUser.v) {
                            val resultN = KtorClient.getUser(userId)
                            if (resultN.isSuccess) {
                                val userResult = resultN.getOrNull()
                                if (userResult != null) {
                                    val finalUser = userResult.toUser()
                                    Preference.setCacheData(getUserIdUrl(userId), finalUser.encodeUserString())
                                    user(finalUser)
                                } else {
                                    user(cacheUser)
                                }
                            } else {
                                user(cacheUser)
                            }
                        } else {
                            user(cacheUser)
                        }
                    } else {
                        user(cacheUser)
                    }
                } else {
                    user(cacheUser)
                }
            }
        } catch (e: Exception) {
            user(null)
        }
    }
}

fun loginPopup() {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Login, message = "Choose Your Login Method", onOtpLoginClick = {
        updateState(getState().copy(dialogUiState = null))
        launchLoginMobile()
    }, onPasswordLoginClick = {
        updateState(getState().copy(dialogUiState = null))
        pushView(Screens.PasswordLogin)
    }, onCloseClick = {
        updateState(getState().copy(dialogUiState = null))
    })))
}

fun chooseImage(onCameraClick: () -> Unit, onGalleryClick: () -> Unit) {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Image, message = "Take a new photo or choose from gallery", onCameraClick = {
        updateState(getState().copy(dialogUiState = null))
        onCameraClick()
    }, onGalleryClick = {
        updateState(getState().copy(dialogUiState = null))
        onGalleryClick()
    }, onCloseClick = {
        updateState(getState().copy(dialogUiState = null))
    })))
}

fun login(userIdOrMobile: String, password: String) {
    if (isMobileUserIdError(userIdOrMobile) || userIdOrMobile.isEmpty() ||
        isUserIdPasswordError(password) || password.isEmpty()) {
        showError("Fill all the details")
    } else {
        showLoading()
        launchDefault {
            val result = KtorClient.getUser(if (isValidMobileNumber(userIdOrMobile)) userIdOrMobile.toU() else userIdOrMobile)
            hideLoading()
            if (result.isSuccess) {
                val user = result.getOrNull()?.toUser()
                if (user != null) {
                  if (user.getPassword() == password) {
                      updateState(getState().copy(user = user.encodeUserString()))
                      Preference.user = getState().user
                      showSuccess("Login Successful")
                      popView()
                  } else {
                      showError("Failed to login wrong password")
                  }
                } else {
                    showError("Failed to login null")
                }
            } else {
                showError("Failed to login")
            }
        }
    }
}